import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Instagram, Facebook, Youtube, MessageCircle } from "lucide-react";
import { STORE, waLink, assetUrl } from "@/config";
import { useSettings } from "@/context/SettingsContext";

export const Footer = () => {
  const { settings } = useSettings();
  return (
    <footer className="dark-luxury text-[#E7D9C7] mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-14">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img src={assetUrl(settings.logo)} alt="Sonia Dry Fruits Jammu" className="h-14 w-14 rounded-full object-cover ring-2 ring-[#D97706]/50" />
              <div>
                <p className="font-display text-xl font-bold text-white leading-none">SONIA <span className="text-[#D97706]">DRY FRUITS</span></p>
                <p className="text-[10px] uppercase tracking-[0.3em] text-[#D97706] mt-1">Jammu · Kashmir</p>
              </div>
            </div>
            <p className="text-sm text-[#B9A794] mt-4 leading-relaxed">
              Premium Kashmiri dry fruits, nuts & saffron — carefully selected, hygienically packed and delivered fresh across India.
            </p>
            <div className="flex gap-3 mt-5">
              {settings.instagram && <a href={settings.instagram} target="_blank" rel="noreferrer" className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#D97706] transition-colors" data-testid="social-instagram"><Instagram size={17} /></a>}
              {settings.facebook && <a href={settings.facebook} target="_blank" rel="noreferrer" className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#D97706] transition-colors" data-testid="social-facebook"><Facebook size={17} /></a>}
              {settings.youtube && <a href={settings.youtube} target="_blank" rel="noreferrer" className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#D97706] transition-colors" data-testid="social-youtube"><Youtube size={17} /></a>}
              {!settings.instagram && !settings.facebook && !settings.youtube && (
                <>
                  <span className="h-9 w-9 grid place-items-center rounded-full bg-white/10"><Instagram size={17} /></span>
                  <span className="h-9 w-9 grid place-items-center rounded-full bg-white/10"><Facebook size={17} /></span>
                  <span className="h-9 w-9 grid place-items-center rounded-full bg-white/10"><Youtube size={17} /></span>
                </>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Shop</h4>
            <ul className="space-y-2.5 text-sm text-[#B9A794]">
              <li><Link to="/shop" className="hover:text-[#D97706]">All Products</Link></li>
              <li><Link to="/categories" className="hover:text-[#D97706]">Categories</Link></li>
              <li><Link to="/shop?badge=bestseller" className="hover:text-[#D97706]">Best Sellers</Link></li>
              <li><Link to="/shop?badge=deal" className="hover:text-[#D97706]">Today's Deals</Link></li>
              <li><Link to="/shop?badge=giftbox" className="hover:text-[#D97706]">Gift Boxes</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Information</h4>
            <ul className="space-y-2.5 text-sm text-[#B9A794]">
              <li><Link to="/about" className="hover:text-[#D97706]">About Us</Link></li>
              <li><Link to="/shipping-delivery" className="hover:text-[#D97706]">Shipping & Delivery</Link></li>
              <li><Link to="/refund-policy" className="hover:text-[#D97706]">Cancellation & Refund</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-[#D97706]">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#D97706]">Terms & Conditions</Link></li>
              <li><Link to="/faq" className="hover:text-[#D97706]">FAQ</Link></li>
              <li><Link to="/track" className="hover:text-[#D97706]">Track Order</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-[#B9A794]">
              <li className="flex gap-2.5"><MapPin size={17} className="text-[#D97706] shrink-0 mt-0.5" /><span>{settings.address}</span></li>
              <li className="flex gap-2.5"><Phone size={17} className="text-[#D97706] shrink-0" /><a href={`tel:${settings.phone}`} className="hover:text-[#D97706]">{settings.phone}</a></li>
              <li className="flex gap-2.5"><MessageCircle size={17} className="text-[#D97706] shrink-0" /><a href={waLink("Hi! I'd like to place an order.")} target="_blank" rel="noreferrer" className="hover:text-[#D97706]">WhatsApp: {settings.whatsapp_number}</a></li>
              <li className="flex gap-2.5"><Clock size={17} className="text-[#D97706] shrink-0" /><span>{settings.hours}</span></li>
            </ul>
            <a href={waLink("Hi! I'd like to place an order.")} target="_blank" rel="noreferrer" className="inline-flex mt-4 rounded-full bg-[#25D366] text-white text-sm font-semibold px-5 py-2.5 hover:brightness-95">Chat on WhatsApp</a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-[#8C7B6A]">© {new Date().getFullYear()} {STORE.name}. All rights reserved.</p>
          <p className="text-xs text-[#8C7B6A]">Secure payments · Cards · UPI · WhatsApp Order · Pan-India Delivery</p>
        </div>
      </div>
    </footer>
  );
};
